<template>
<v-row class='elevation-0 title px-1 ma-0'>
  <v-icon class='mr-1' color='primary lighten-1'>
    {{ icon }}
  </v-icon>
  <span class='elevation-0 primary--text text--lighten-1 headline'>
    {{ title }}
  </span>
</v-row>
</template>


<script>
export default {
  props: ['icon', 'title'],
  data: () => ({

  }),
  computed: {

  }
}
</script>


<style lang='stylus' scoped>
.title
  *
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1)
  span
    // font-size: 23px
    font-weight: bold

</style>
